import { render, staticRenderFns } from "./ComplexProductComplianceOverview.vue?vue&type=template&id=37c9bbdb&"
import script from "./ComplexProductComplianceOverview.vue?vue&type=script&lang=js&"
export * from "./ComplexProductComplianceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports